import { AmlDetails, CommonLayout, Footer, NomineeTable } from '../commonComponents';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {
  Box,
  Button,
  CardMedia,
  Grid,
  IconButton,
  LinearProgress,
  Typography,
  Dialog,
  Tooltip,
  Stepper,
  StepConnector,
  stepConnectorClasses,
  Step,
  StepButton,
  StepLabel,
  StepIconProps,
  StepIcon,
  Stack,
  Hidden,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { Theme, styled, useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  getApplicationDetails,
  getDocuments,
  isFormValidForSubmission,
  kraReverification,
  nonIndividualFormValidForSubmission,
  updateApplication,
} from '../../redux-store/actions/application';
import ContactDetails from './contactDetails';
import KycDetails from './kycDetails';
import FatcaDetails from './FatcaDetails';
import NomineeDetails from './nomineeDetails';
import InvestAndPaymentDetails from './InvestmentAndPayment';
import BankDetails from './BankDetails';
import DocumentDetails from './DocumentDetails';
import {
  ApplicationProps,
  DataMaster,
  DataMasters,
  Document,
  FamilyMembers,
  nationaliyType,
  NomineeType,
  RiskProfileMaster,
} from '../../redux-store/types/api-types';
import {
  REJECTED_ROLES,
  USER_ROLES,
  APPLICATION_STATUS,
  ApplicationStatusBasedOnRole,
  APPLICATION_TYPE,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  IndividualApplicationStatusBasedOnRole,
  APPLICATION_STATUS_AMCAPPROVER_individual,
  APPLICATION_LISTING_STATUS,
  PHYSICAL_DIGITAL_FLOW,
  ONBOARDING_DEMAT_DETAILS,
  NEXEDGE_INVESTMENT_PREFERENCE,
  TCL_ONBOARDING_TYPE,
  ESIGN_STATUS,
  APPLICATION_RE_KYC_STATUS,
  NO_NOMINEE_DISCLAIMER,
  DISABLE_NOMINEE_OPY_OUT,
  SUBROLE,
} from '../../utils/constant';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import * as yup from 'yup';
import { Formik } from 'formik';
import CloseIcon from '@mui/icons-material/Close';
import { MFTextField } from '../../lib/formik';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import LoadingButton from '@mui/lab/LoadingButton';
import { formatShortDateAndTime } from '../../utils/date';
import {
  applyRoleBasedStatus,
  checkIfApplicationIsNonIndividual,
  isOnboardingTypeMinor,
  sendApplication_Nri,
} from '../../utils/utilityFunctions';
import { NonIndividualApplicationLayout } from '../NonIndividualApplicationDetails';
import { showError } from '../../redux-store/actions/auth';
import { ConfirmationDialog } from '../commonComponents';
import DistributorDetails from './rmDetails';
import RelatedPersonDetails from './relatedPersonDetails';
// import { getNationalityList } from '../../redux-store/actions/userManagement';
import PersonalDetails, { KeyValue } from './personalDetails';
import RiskProfiles from './RiskProfiles';
import { riskProfileMasterData } from '../../redux-store/actions';
import { TermsAndConditionsCard } from './TermsAndConditions';
import ServicePreference from './servicePreferenceDetails';
import InvestmentPreference from './investmentPreferenceDetails';
import RMConcentForBSE from './rmConsentBse';
import Comments from './Comments';
import { EditIcon, StepperSuccessIcon, SuccessIcon } from '../../assets/SvgIcons';
import InvOnboardingLayout from '../InvestorOnboarding/InvOnboardingLayout';
import NexEdgeInvestmentPreference from './NexEdgeInvPref';
import DematDetails from './DematDetails';
import { EsignData, getEsignLink } from '../../redux-store/actions/esign';
import StatusDetails from './StatusDetails';
import { GetConsentOtp, GetConsentOtpBody } from '../../redux-store/actions/otpConsent';
import { getDataMasters } from '../../redux-store/actions/onBoarding';
import { useSnackbar } from 'notistack';
import { KraReverificationResponseBody } from '../../redux-store/types/application';
import ClientInvestmentPreview from './ClientInvestmentPreview';
import { IndividualMenuList, NonIndividualMenuList } from '../investors/components';

export const Item = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  paddingTop: '10px',
  marginLeft: '2px',
  color: theme.palette.text.secondary,
  fontSize: '15px',
  fontWeight: 500,
  letterSpacing: '0.5px',
}));
export const ItemDetails = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  fontSize: '16px',
  marginLeft: '2px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  maxWidth: '100%',
  overflowWrap: 'anywhere',
}));
export const Gridstyles = styled('div')(({ theme }) => ({
  paddingLeft: '10%',
  width: '100%',
  [theme.breakpoints.only('xs')]: {
    paddingLeft: 0,
  },
}));

const BootstrapStepConnector = styled(StepConnector)(({ theme }) => ({
  [`& .${stepConnectorClasses.line}`]: {
    flexDirection: "column",
    height: 5,
    borderLeftWidth: "1px",
    borderLeftColor: `${theme.palette.text.secondary}26`,
    borderLeftStyle: "solid"
  },
}));

const NonIndividualMenuItemList = [
  'RM details',
  'Entity Details',
  'Contact Details',
  'Investment & Payment Details',
  "Bank Details",
  ...(ONBOARDING_DEMAT_DETAILS ? ["Investor's DP Details"] : []),
  'Document Details',
  'Authorised Signatory',
  'Declaration of UBO',
  'FATCA',
  // 'Risk Profile',
];

const MenuItemList = [
  'RM Details',
  'Personal Details',
  // 'Details of Related Person',
  'Contact Details',
  'Additional Details',
  'Nominee Details',
  'FATCA Declaration',
  'Bank Details',
  ...(ONBOARDING_DEMAT_DETAILS ? ['DP Details'] : []),
  'Risk Profiles',
  // 'Investment Preference',
  // 'Client Investment Information',
  // 'Service Preference',
  'Upload Documents',
];

const NonIndividualMenuItemListLink = [
  'distributor-details',
  'personal-details',
  'contact-details',
  'investment-payment-details',
  'bank-details',
  ...(ONBOARDING_DEMAT_DETAILS ? ['dp-details'] : []),
  'document-details',
  'authorised-signatory',
  'declaration-ubo',
  // 'fatca',
  // 'risk-profile',
];

const MenuItemListLink = [
  'rm-details',
  'personal-details',
  // 'related-person-details',
  'contact-details',
  'additional-KYC-details',
  'nominee-details',
  'fatca',
  'bank-details',
  ...(ONBOARDING_DEMAT_DETAILS ? ["dp-details"] : []),
  'risk-profiles',
  // 'investment-preference',
  // 'client-investment-information',
  // 'service-preference',
  'document-details',
];

export function RejectedDetails({
  title,
  description,
}: {
  title: string | null;
  description: string | null;
}): JSX.Element {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <Typography sx={{ fontSize: 17, fontWeight: 500, color: 'text.secondary' }}>
          {title}:{' '}
          <Typography
            component="span"
            sx={{
              color: 'text.secondary',
              fontSize: '16px',
              letterSpacing: '0.4px',
              fontWeight: 700,
              ml: { sm: 0.5 },
            }}>
            {description}
          </Typography>
        </Typography>
      </Grid>
    </>
  );
}

export function ApplicationDetailsCommonLayout({
  loading,
  application,
}: {
  loading: boolean;
  application: ApplicationProps;
}): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { path: currentPath } = useRouteMatch();
  const { onboardingVia = '', families, applicants = [] } = application || {};
  const dispatch = useDispatch();
  const [dataMasters, setDataMasters] = useState<DataMaster>({} as DataMaster);

  const isDiyInvOnboardingApplicationDetails = currentPath.includes('investor-onboarding-application-details')
  const isDiyInvOnboardingApplicationPreview = currentPath.includes('investor-onboarding-application-preview')

  useEffect(() => {
    (async () => {
      const res = (await dispatch(getDataMasters())) as unknown as DataMasters;
      if (res?.data) {
        setDataMasters(res?.data ?? {});
      }
    })();
  }, []);

  return (
    <>
      {loading && <LinearProgress />}
      {application && (
        <>
          {/* <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
            }}
            mb={3}>
            <Box sx={{ p: 2 }}>
              <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  mb={2}>
                  <Typography
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                    }}>
                    Application ID: {application.applicationNumber}
                  </Typography>
                  {application.clientCode && (
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: 'text.secondary',
                      }}>
                      Client Code : {application.clientCode}
                    </Typography>
                  )}
                  <Typography
                    className={
                      application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                          ? role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                          : !checkIfApplicationIsNonIndividual(application) &&
                            role === USER_ROLES.AMCAPPROVER
                            ? IndividualApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                    }
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                      '&.Draft .MuiTypography-root': {
                        color: 'rgba(51, 127, 201, 0.7)',
                      },
                      '&.Completed .MuiTypography-root': {
                        fontWeight: 600,
                        color: 'rgba(35, 133, 63, 0.7)',
                      },
                      '&.Rejected .MuiTypography-root': {
                        color: '#BD2932',
                        fontWeight: 500,
                      },
                    }}>
                    Status:{' '}
                    <Typography
                      component="span"
                      sx={{
                        color: '#B78813',
                        fontSize: '16px',
                        letterSpacing: '0.4px',
                        ml: 0.5,
                      }}>
                      {application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                          ? role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                          : !checkIfApplicationIsNonIndividual(application) &&
                            role === USER_ROLES.AMCAPPROVER
                            ? IndividualApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]}
                    </Typography>
                  </Typography>
                  {[
                    USER_ROLES.RM,
                    USER_ROLES.DISTRIBUTOR,
                    USER_ROLES.SUBDISTRIBUTOR,
                    USER_ROLES.AMCAPPROVER,
                    USER_ROLES.AMC_ADMIN,
                  ].includes(role) &&
                    application.signedLeegalityFile?.url && (
                      <Tooltip title={'Download'}>
                        <IconButton
                          sx={{
                            p: 0,
                            pr: 0.5,
                            ':hover': {
                              bgcolor: '#F4FCFC',
                            },
                            cursor: 'pointer',
                            pointerEvents: 'all',
                          }}
                          onClick={() =>
                            application.signedLeegalityFile?.url &&
                            window.open(application.signedLeegalityFile?.url)
                          }>
                          <CardMedia
                            component="img"
                            src={'/images/download-icon.png'}
                            alt="Download"
                            sx={{ width: '25px' }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                </Grid>
                {application.status === 'rejected' && (
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={1}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <RejectedDetails
                      title={'Rejected by'}
                      description={REJECTED_ROLES[application.rejectedByRole]}
                    />
                    <RejectedDetails
                      title={'Rejected on'}
                      description={formatShortDateAndTime(application.rejectedAt)}
                    />
                    <RejectedDetails
                      title={'Reason for rejection'}
                      description={application.rejectedReason}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box> */}
          {PHYSICAL_DIGITAL_FLOW && (<Typography
            variant='body_600'
            sx={(theme: Theme) => ({
              // marginLeft: "35px",
              color: theme.palette.text.primary,
              mt: 3,
              mb: 2
            })}
          >
            {/* {`Onboarding Type : ${onboardingVia?.toUpperCase()}`} */}
            KYC Method: {TCL_ONBOARDING_TYPE[applicants[0]?.kycMethod as string]}
          </Typography>
          )}
          {/* {[
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM,
            USER_ROLES.ONBOARDING_SPECIALIST,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR
          ].includes(role) && (
              <div id="rm-details">
                <RMConcentForBSE application={application} />
              </div>
            )} */}
          {/* {USER_ROLES.INVESTOR !== role && (
            <AmlDetails
              applicants={application.applicants}
              applicationType={application.applicationType}
            />
          )} */}
          {(isDiyInvOnboardingApplicationPreview || isDiyInvOnboardingApplicationDetails || role !== USER_ROLES.INVESTOR) && application.comments.length > 0 && (
            <Comments application={application} />
          )}
          {(isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview || role !== USER_ROLES.INVESTOR) && <DistributorDetails application={application} isDiyInvestorOnboarding={isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview} />}

          {(application?.modeOfHolding ?? '').toLowerCase() === 'joint' &&
            (<div id='status-details'>
              <StatusDetails
                application={application}
              />

            </div>)
          }

          <div id='personal-details'>

            <PersonalDetails
              applicants={application.applicants}
              modeOfHolding={application.modeOfHolding}
            />
          </div>

          {/* <div id="related-person-details">
            <RelatedPersonDetails applicants={application.applicants} />
          </div> */}
          <div id='contact-details'>

            <ContactDetails applicants={application.applicants} />
          </div>

          <div id='additional-KYC-details'>

            <KycDetails applicants={application.applicants} families={families as FamilyMembers[]} dataMasters={dataMasters} />
          </div>

          <div id='nominee-details'>

            <NomineeDetails nominees={application.nominees} application={application} />
          </div>
          <div id='fatca'>
            <FatcaDetails applicants={application.applicants} />
          </div>
          <div id="bank-details">

            <BankDetails banks={application.banks} />
          </div>
          {ONBOARDING_DEMAT_DETAILS && (
            <div id="dp-details">
              <DematDetails demats={application.demats} />
            </div>
          )}
          <div id='risk-profiles'>

            <RiskProfiles application={application} />
          </div>
          {/* <div id='investment-preference'>
            <InvestmentPreference application={application} />
          </div> */}
          {/* <div id='client-investment-information'>
            <ClientInvestmentPreview />
          </div> */}
          {/* <div id='investment-preference'>
            {NEXEDGE_INVESTMENT_PREFERENCE ? <NexEdgeInvestmentPreference application={application} /> :
              <InvestmentPreference application={application} />}
          </div> */}
          {/* {!NEXEDGE_INVESTMENT_PREFERENCE ? (
            <div id='service-preference'>
              <ServicePreference application={application} />
            </div>
          ) : null} */}
          <div id='document-details'>
            <DocumentDetails application={application} />
          </div>
          <TermsAndConditionsCard application={application} />
        </>
      )}
    </>
  );
}

const RejectApproveButtons = ({
  handleOpen,
  handleDialogOpen,
  handleSendBack,
  approve,
  reject,
  sendBack,
}: {
  handleOpen: () => void;
  handleDialogOpen: () => void;
  handleSendBack: () => void;
  approve: boolean;
  reject: boolean;
  sendBack: boolean;
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  return (
    <Grid display="flex" justifyContent="center" alignItems="center">
      <LoadingButton
        loadingPosition="start"
        type="submit"
        loading={reject}
        variant="outlined"
        // sx={{
        //   fontSize: 15,
        //   minWidth: 180,
        //   letterSpacing: 2,
        //   fontWeight: 400,
        // }}
        sx={{
          color: 'primary.main',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          mr: 3,
        }}
        onClick={handleOpen}
        disabled={approve || sendBack}>
        Reject
      </LoadingButton>
      <LoadingButton
        loadingPosition="start"
        type="submit"
        loading={approve}
        variant="contained"
        // sx={{
        //   fontSize: 15,
        //   minWidth: 180,
        //   letterSpacing: 2,
        //   fontWeight: 400,
        // }}
        sx={{
          color: 'common.white',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          ml: 3,
          mr: USER_ROLES.AMCAPPROVER === role ? 3 : 0,
        }}
        onClick={handleDialogOpen}
        disabled={reject || sendBack}>
        Approve
      </LoadingButton>
      {/* {USER_ROLES.AMCAPPROVER === role && ( */}
      {/* <LoadingButton
        loadingPosition="start"
        type="submit"
        loading={sendBack}
        variant="contained"
        sx={{
          color: 'common.white',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          ml: 3,
        }}
        onClick={handleSendBack}
        disabled={reject || approve}>
        Send Back
      </LoadingButton> */}
      {/* )} */}
      {/* <Button
        variant="contained"
        sx={{
          color: 'common.white',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          ml: 3,
        }}
        onClick={handleDialogOpen}>
        Approve
      </Button> */}
    </Grid>
  );
};

//Read only view for POA and Non Individual Application for AMC Approver,Individual Application for AMC Approver and POA Approver
const PoaOrNIApplicationDetails = ({
  loading,
  application,
}: {
  loading: boolean;
  application: ApplicationProps;
}): JSX.Element => {
  const { status, editable, applicationType } = application || {};
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR", locale = "en-IN" } = useSelector((store: RootStateType) => store.currencyInfo);
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation()
  const { path, url } = useRouteMatch();

  const { kycMethod = 'osv', addresses } = application?.applicants[0] || {}; // consideration only for primary holder as per tcl so using [0]th index
  const permanentAddressSameAsCorresponding = addresses?.find((address) => address.address_type === 'correspondence')?.permanentAddressSameAsCorresponding ?? false;
  const pennyDropVerified = application?.banks?.find((bank) => bank.pennydropVerified)?.defaultBankAccount ?? false;
  const bankRequired = !pennyDropVerified && isOnboardingTypeMinor((application?.applicants[0]?.onboardingType as string) || '') && `${application?.applicants[0]?.status}`.toLowerCase() !== 'individual';


  const validateForm = async () => {
    // const nationalitiesMdmsMasters = (await dispatch(
    //   getNationalityList()
    // )) as unknown as nationaliyType;
    const { data: dataMasters } = (await dispatch(getDataMasters())) as unknown as DataMasters;
    const documentsResponse = (await dispatch(getDocuments())) as unknown as Document;
    const responseRiskProfile = (await dispatch(
      riskProfileMasterData({
        riskProfileGroup: application?.applicants[0]?.riskProfileGroup ?? null,
        company: application?.company ?? null
      })
    )) as unknown as RiskProfileMaster;
    const nationalitiesMdmsMasters = { countries: dataMasters?.COUNTRY || [] };
    if (application?.applicationType?.toLowerCase() === "individual") {
      await isFormValidForSubmission(
        application as ApplicationProps,
        true,
        true,
        nationalitiesMdmsMasters,
        documentsResponse,
        role,
        responseRiskProfile.riskProfile,
        currencyCode,
        company,
        dataMasters,
        kycMethod,
        permanentAddressSameAsCorresponding,
        bankRequired
      );
    }
    if (application?.applicationType?.toLowerCase() === "non_individual") {
      const { applicants = [] } = application || {};
      const getInvestorType = applicants[0]?.investorType?.toString();

      if (getInvestorType && Object.keys(documentsResponse).includes(getInvestorType)) {
        await nonIndividualFormValidForSubmission(
          application,
          documentsResponse[getInvestorType] ?? [],
          nationalitiesMdmsMasters.countries,
          undefined,
          currencyCode,
          locale,
          true
        );
      }
    }
  };

  const handleOpen = () => setOpen(true);
  const handleDialogOpen = async () => {
    try {
      setApproveLoading(true);
      await validateForm();
      setApproveLoading(false);
      setOpenDialog(true);
    } catch (e) {
      setApproveLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  const initialCommentValues: Partial<ApplicationProps> = { comment: '' };
  const Commentvalidation = yup.object().shape({
    comment: yup.string().required('Please provide Comment'),
  });
  const handleSendBack = () => setOpenSendBackDialog(true);
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);
  const [sendBackLoading, setSendBackLoading] = useState(false);
  const handleSendBackClose = () => {
    setOpenSendBackDialog(false), setSendBackLoading(false);
  };
  const handleClose = () => {
    setOpen(false), setApproveLoading(false);
  };
  const handleDialogClose = () => {
    setOpenDialog(false), setRejectLoading(false);
  };

  const initialValues: Partial<ApplicationProps> = { rejectedReason: '' };
  const resonValidation = yup.object().shape({
    rejectedReason: yup.string().required('Please enter the reason for rejection'),
  });
  const onSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleClose();
      setRejectLoading(true);
      if (application) {
        const res = await dispatch(
          updateApplication({
            body: {
              ...application,
              rejectedReason: values.rejectedReason,
              status: 'rejected',
            },
            applicationId: application.id,
          })
        );
        if (!res) {
          return;
        }
        history.push('/applications-list');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setRejectLoading(false);
    }
  };
  const onSendBackSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleSendBackClose();
      setSendBackLoading(true);
      if (application) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              comment: values.comment,
              status: 'draft',
              applicationSentBack: true,
            },
            applicationId: application.id,
          })
        );
        history.push('/applications-list');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSendBackLoading(false);
    }
  };
  return (
    USER_ROLES.AMCAPPROVER.includes(role)
      ?
      // <CommonLayoutForPOA>
      <CommonLayout>
        <>
          <Box sx={{ px: { xs: 2, sm: 5 }, mt: { xs: 2, sm: 3 } }} ref={applicationDetailRef}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                justifyContent: 'space-between',
                // mt: 5,
              }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "15px"
                }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications-list"
                    disabled={approveLoading || rejectLoading}>
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                  </IconButton>
                  <Typography
                    variant='h2'
                    sx={(theme: Theme) => ({
                      // fontSize: 20,
                      // fontWeight: 600,
                      color: theme.palette.primary[500]
                    })}
                  >
                    Application Details
                  </Typography>
                </Box>
                <Typography
                  variant='body_600'
                  sx={(theme: Theme) => ({
                    marginLeft: "35px",
                    color: theme.palette.text.primary
                  })}
                >
                  {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor` :
                    ""
                  }
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL)
                    ? application.modeOfHolding === 'single'
                      ? `Individual Investor Onboarding`
                      : `Joint Investor Onboarding`
                    : ""
                  }
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor` :
                    ""
                  }
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end'
                }}
              >
                {editable && !([USER_ROLES.AMCAPPROVER].includes(role)) && application?.modeOfHolding === 'single' && (
                  <IconButton>
                    <CardMedia
                      component="img"
                      src="/images/edit-icon-outlined.svg"
                      alt="Edit Icon"
                      sx={{ width: 'unset' }}
                      onClick={() =>
                        history.push(
                          role === USER_ROLES.POAAPPROVER
                            ? `/investment-details/edit-application`
                            : !checkIfApplicationIsNonIndividual(application) &&
                              USER_ROLES.AMCAPPROVER === role
                              ? `/application-checker-details/edit-application`
                              : `/non-individual-application-edit`,
                          {
                            id: application?.id,
                          }
                        )
                      }
                    />
                  </IconButton>

                )}
                {(application?.applicationNumber && path === "/application-details/:id") && <Typography variant="body_600">{`Application ID: ${application?.applicationNumber}`}</Typography>}

              </Box>
            </Box>
            <IconButton
              sx={{
                position: 'fixed',
                right: 0,
                bottom: 75,
                borderRadius: '5px  0 0 5px',
                '&,:hover': {
                  bgcolor: 'primary.main',
                },
              }}
              onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
              <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
            </IconButton>
            {applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? (
              <NonIndividualApplicationLayout loading={loading} application={application} />
            ) : (
              <ApplicationDetailsCommonLayout loading={loading} application={application} />
            )}
            {application &&
              ((USER_ROLES.AMCAPPROVER === role && status === 'sent_to_amc_approver') ||
                (USER_ROLES.POAAPPROVER === role && status === 'sent_to_poa_approver') ? (
                <RejectApproveButtons
                  handleOpen={handleOpen}
                  handleDialogOpen={handleDialogOpen}
                  approve={approveLoading}
                  reject={rejectLoading}
                  sendBack={sendBackLoading}
                  handleSendBack={handleSendBack}
                />
              ) : (
                <Box sx={{ textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    sx={{
                      color: 'common.white',
                      minWidth: '200px',
                      mt: 4,
                      fontWeight: 600,
                      lineHeight: 1.5,
                    }}
                    onClick={() => {
                      history.push('/applications-list');
                    }}>
                    Done
                  </Button>
                </Box>
              ))}
            <Dialog
              onClose={handleClose}
              open={open}
              sx={{
                '.MuiPaper-root ': {
                  p: 4,
                  width: { xs: '70%', sm: '70%' },
                },
              }}>
              <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
              <Box sx={{ mb: 2 }}>
                <CardMedia
                  component="img"
                  src="/images/warning-icon-red.svg"
                  sx={{ width: 'unset', mx: 'auto' }}
                />
              </Box>
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 18,
                    fontWeight: 500,
                    textAlign: 'center',
                  },
                }}>
                <Typography sx={{ color: 'primary.main' }}>
                  Are you sure you want to{' '}
                  <Typography component="span" sx={{ color: '#BD2932' }}>
                    Reject
                  </Typography>{' '}
                  the application
                </Typography>
                <Typography sx={{ color: '#BD2932', mt: 5 }}>
                  {' '}
                  Give reason for application rejection *
                </Typography>
                <Formik
                  initialValues={initialValues}
                  onSubmit={onSubmit}
                  validationSchema={resonValidation}>
                  {({ handleSubmit }) => (
                    <Box component="form" noValidate onSubmit={handleSubmit}>
                      <MFTextField
                        name="rejectedReason"
                        multiline
                        rows={4}
                        placeholder="Type your answer here..."
                      />

                      <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                        <Button
                          onClick={() => {
                            handleClose();
                          }}
                          variant="outlined"
                          sx={{
                            fontSize: 15,
                            color: 'primary.main',
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 500,
                          }}>
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          sx={{
                            fontSize: 15,
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 400,
                          }}
                          type="submit">
                          Continue
                        </Button>
                      </Grid>
                    </Box>
                  )}
                </Formik>
              </Box>
            </Dialog>
            <Dialog
              onClose={handleDialogClose}
              open={openDialog}
              sx={{
                '.MuiPaper-root ': {
                  p: 4,
                  width: { xs: '70%', sm: '70%' },
                },
              }}>
              <IconButton onClick={handleDialogClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 20,
                    fontWeight: 500,
                    textAlign: 'center',
                  },
                }}>
                <Typography sx={{ color: 'primary.main' }}>
                  Are you sure you want to{' '}
                  <Typography component="span" sx={{ color: 'green' }}>
                    Approve
                  </Typography>{' '}
                  the application
                </Typography>
              </Box>
              <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                <Button
                  onClick={() => {
                    handleDialogClose();
                  }}
                  variant="outlined"
                  sx={{
                    fontSize: 15,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 400,
                  }}
                  onClick={async () => {
                    try {
                      handleDialogClose();
                      setApproveLoading(true);
                      const res = await dispatch(
                        updateApplication({
                          body: {
                            ...application,
                            status:
                              USER_ROLES.POAAPPROVER === role &&
                                application?.status === 'sent_to_poa_approver'
                                ? 'sent_to_amc_approver'
                                : USER_ROLES.AMCAPPROVER === role &&
                                  application?.status === 'sent_to_amc_approver'
                                  ? !application?.isEsignEnabled
                                    ? 'completed'
                                    : application?.hasPOA
                                      ? 'sent_to_authorised_signatories'
                                      : sendApplication_Nri(application) ||
                                        (AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                                          !checkIfApplicationIsNonIndividual(application))
                                        ? 'completed'
                                        : 'sent_to_authorised_signatories'
                                  : application?.status,
                          },
                          applicationId: application.id,
                        })
                      );
                      if (!res) {
                        return;
                      }
                      history.push('/applications-list');
                    } catch (e) {
                      console.error((e as Error).message);
                    } finally {
                      setApproveLoading(false);
                    }
                  }}>
                  Continue
                </Button>
              </Grid>
            </Dialog>
            <Dialog
              onClose={handleSendBackClose}
              open={openSendBackDialog}
              sx={{
                '.MuiPaper-root ': {
                  p: 4,
                  width: { xs: '70%', sm: '70%' },
                },
              }}>
              <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
              {/* <Box sx={{ mb: 2 }}>
            <CardMedia
              component="img"
              src="/images/warning-icon-red.svg"
              sx={{ width: 'unset', mx: 'auto' }}
            />
          </Box> */}
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 18,
                    fontWeight: 500,
                    textAlign: 'justify',
                  },
                }}>
                <Typography sx={{ color: 'primary.main' }}>
                  Are you sure you want to{' '}
                  <Typography component="span" sx={{ color: '#BD2932' }}>
                    Send Back
                  </Typography>{' '}
                  the application
                </Typography>
                <Typography sx={{ color: '#BD2932', mt: 5 }}> Provide Comments *</Typography>
                <Formik
                  initialValues={initialCommentValues}
                  onSubmit={onSendBackSubmit}
                  validationSchema={Commentvalidation}>
                  {({ handleSubmit }) => (
                    <Box component="form" noValidate onSubmit={handleSubmit}>
                      <MFTextField
                        name="comment"
                        multiline
                        rows={4}
                        placeholder="Type your answer here..."
                      />

                      <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                        <Button
                          onClick={handleSendBackClose}
                          variant="outlined"
                          sx={{
                            fontSize: 15,
                            color: 'primary.main',
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 500,
                          }}>
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          sx={{
                            fontSize: 15,
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 400,
                          }}
                          type="submit">
                          Continue
                        </Button>
                      </Grid>
                    </Box>
                  )}
                </Formik>
              </Box>
            </Dialog>
          </Box>
        </>
        {/* </CommonLayoutForPOA > */}
      </CommonLayout>
      :
      (
        <Box
          sx={{
            bgcolor: { xs: '', sm: 'rgba(238, 244, 251, 0.5)' },
          }}>
          {/* <CommonLayoutForPOA> */}
          <CommonLayout>
            <>
              <Box sx={{ py: 3, px: { xs: 2, sm: 10 }, mt: { xs: 7, sm: 10 } }} ref={applicationDetailRef}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 2,
                    justifyContent: 'space-between',
                    // mt: 5,
                  }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "15px"
                    }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton
                        sx={{ height: 'fit-content', p: 0 }}
                        component={RouterLink}
                        to="/applications-list"
                        disabled={approveLoading || rejectLoading}>
                        <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                      </IconButton>
                      <Typography
                        variant='h2'
                        sx={(theme: Theme) => ({
                          // fontSize: 20,
                          // fontWeight: 600,
                          color: theme.palette.primary[500]
                        })}
                      >
                        Application Details
                      </Typography>
                    </Box>
                    <Typography
                      variant='body_600'
                      sx={(theme: Theme) => ({
                        marginLeft: "35px",
                        color: theme.palette.text.primary
                      })}
                    >
                      {application?.onboardingType?.toLowerCase() === "minor" ?
                        `Minor Investor` :
                        ""
                      }
                      {(application?.onboardingType?.toLowerCase() === "normal" &&
                        application?.applicationType === APPLICATION_TYPE.INDIVIDUAL)
                        ? application.modeOfHolding === 'single'
                          ? `Individual Investor Onboarding`
                          : `Joint Investor Onboarding`
                        : ""
                      }
                      {(application?.onboardingType?.toLowerCase() === "normal" &&
                        application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                        `Non Individual Investor` :
                        ""
                      }
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end'
                    }}
                  >
                    {editable && application?.modeOfHolding === 'single' && (
                      <IconButton>
                        <CardMedia
                          component="img"
                          src="/images/edit-icon-outlined.svg"
                          alt="Edit Icon"
                          sx={{ width: 'unset' }}
                          onClick={() =>
                            history.push(
                              role === USER_ROLES.POAAPPROVER
                                ? `/investment-details/edit-application`
                                : !checkIfApplicationIsNonIndividual(application) &&
                                  USER_ROLES.AMCAPPROVER === role
                                  ? `/investment-details/edit-application`
                                  : `/non-individual-application-edit`,
                              {
                                id: application?.id,
                              }
                            )
                          }
                        />
                      </IconButton>

                    )}
                    {(application?.applicationNumber && path === "/application-details/:id") && <Typography variant="body_600">{`Application ID: ${application?.applicationNumber}`}</Typography>}

                  </Box>
                </Box>
                <IconButton
                  sx={{
                    position: 'fixed',
                    right: 0,
                    bottom: 75,
                    borderRadius: '5px  0 0 5px',
                    '&,:hover': {
                      bgcolor: 'primary.main',
                    },
                  }}
                  onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
                  <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
                </IconButton>
                {applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? (
                  <NonIndividualApplicationLayout loading={loading} application={application} />
                ) : (
                  <ApplicationDetailsCommonLayout loading={loading} application={application} />
                )}
                {application &&
                  ((USER_ROLES.AMCAPPROVER === role && status === 'sent_to_amc_approver') ||
                    (USER_ROLES.POAAPPROVER === role && status === 'sent_to_poa_approver') ? (
                    <RejectApproveButtons
                      handleOpen={handleOpen}
                      handleDialogOpen={handleDialogOpen}
                      approve={approveLoading}
                      reject={rejectLoading}
                      sendBack={sendBackLoading}
                      handleSendBack={handleSendBack}
                    />
                  ) : (
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        sx={{
                          color: 'common.white',
                          minWidth: '200px',
                          mt: 4,
                          fontWeight: 600,
                          lineHeight: 1.5,
                        }}
                        onClick={() => {
                          history.push('/applications-list');
                        }}>
                        Done
                      </Button>
                    </Box>
                  ))}
                <Dialog
                  onClose={handleClose}
                  open={open}
                  sx={{
                    '.MuiPaper-root ': {
                      p: 4,
                      width: { xs: '70%', sm: '70%' },
                    },
                  }}>
                  <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  <Box sx={{ mb: 2 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset', mx: 'auto' }}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: { xs: '100%', sm: '80%' },
                      mx: 'auto',
                      '.MuiTypography-root': {
                        fontSize: 18,
                        fontWeight: 500,
                        textAlign: 'center',
                      },
                    }}>
                    <Typography sx={{ color: 'primary.main' }}>
                      Are you sure you want to{' '}
                      <Typography component="span" sx={{ color: '#BD2932' }}>
                        Reject
                      </Typography>{' '}
                      the application
                    </Typography>
                    <Typography sx={{ color: '#BD2932', mt: 5 }}>
                      {' '}
                      Give reason for application rejection *
                    </Typography>
                    <Formik
                      initialValues={initialValues}
                      onSubmit={onSubmit}
                      validationSchema={resonValidation}>
                      {({ handleSubmit }) => (
                        <Box component="form" noValidate onSubmit={handleSubmit}>
                          <MFTextField
                            name="rejectedReason"
                            multiline
                            rows={4}
                            placeholder="Type your answer here..."
                          />

                          <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                            <Button
                              onClick={() => {
                                handleClose();
                              }}
                              variant="outlined"
                              sx={{
                                fontSize: 15,
                                color: 'primary.main',
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 500,
                              }}>
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                fontSize: 15,
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 400,
                              }}
                              type="submit">
                              Continue
                            </Button>
                          </Grid>
                        </Box>
                      )}
                    </Formik>
                  </Box>
                </Dialog>
                <Dialog
                  onClose={handleDialogClose}
                  open={openDialog}
                  sx={{
                    '.MuiPaper-root ': {
                      p: 4,
                      width: { xs: '70%', sm: '70%' },
                    },
                  }}>
                  <IconButton onClick={handleDialogClose} sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  <Box
                    sx={{
                      width: { xs: '100%', sm: '80%' },
                      mx: 'auto',
                      '.MuiTypography-root': {
                        fontSize: 20,
                        fontWeight: 500,
                        textAlign: 'center',
                      },
                    }}>
                    <Typography sx={{ color: 'primary.main' }}>
                      Are you sure you want to{' '}
                      <Typography component="span" sx={{ color: 'green' }}>
                        Approve
                      </Typography>{' '}
                      the application
                    </Typography>
                  </Box>
                  <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                    <Button
                      onClick={() => {
                        handleDialogClose();
                      }}
                      variant="outlined"
                      sx={{
                        fontSize: 15,
                        color: 'primary.main',
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 500,
                      }}>
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        fontSize: 15,
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 400,
                      }}
                      onClick={async () => {
                        try {
                          handleDialogClose();
                          setApproveLoading(true);
                          const res = await dispatch(
                            updateApplication({
                              body: {
                                ...application,
                                status:
                                  USER_ROLES.POAAPPROVER === role &&
                                    application?.status === 'sent_to_poa_approver'
                                    ? 'sent_to_amc_approver'
                                    : USER_ROLES.AMCAPPROVER === role &&
                                      application?.status === 'sent_to_amc_approver'
                                      ? !application?.isEsignEnabled
                                        ? 'completed'
                                        : application?.hasPOA
                                          ? 'sent_to_authorised_signatories'
                                          : sendApplication_Nri(application) ||
                                            (AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                                              !checkIfApplicationIsNonIndividual(application))
                                            ? 'sent_to_applicant1'
                                            : 'sent_to_authorised_signatories'
                                      : application?.status,
                              },
                              applicationId: application.id,
                            })
                          );
                          if (!res) {
                            enqueueSnackbar('Something went wrong', {
                              variant: 'error',
                              autoHideDuration: 3000,
                            });
                            return;
                          }
                          enqueueSnackbar('Application Approved Successfully', {
                            variant: 'success',
                            autoHideDuration: 3000,
                          });
                          history.push('/applications-list');
                        } catch (e) {
                          console.error((e as Error).message);
                        } finally {
                          setApproveLoading(false);
                        }
                      }}>
                      Continue
                    </Button>
                  </Grid>
                </Dialog>
                <Dialog
                  onClose={handleSendBackClose}
                  open={openSendBackDialog}
                  sx={{
                    '.MuiPaper-root ': {
                      p: 4,
                      width: { xs: '70%', sm: '70%' },
                    },
                  }}>
                  <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  {/* <Box sx={{ mb: 2 }}>
            <CardMedia
              component="img"
              src="/images/warning-icon-red.svg"
              sx={{ width: 'unset', mx: 'auto' }}
            />
          </Box> */}
                  <Box
                    sx={{
                      width: { xs: '100%', sm: '80%' },
                      mx: 'auto',
                      '.MuiTypography-root': {
                        fontSize: 18,
                        fontWeight: 500,
                        textAlign: 'justify',
                      },
                    }}>
                    <Typography sx={{ color: 'primary.main' }}>
                      Are you sure you want to{' '}
                      <Typography component="span" sx={{ color: '#BD2932' }}>
                        Send Back
                      </Typography>{' '}
                      the application
                    </Typography>
                    <Typography sx={{ color: '#BD2932', mt: 5 }}> Provide Comments *</Typography>
                    <Formik
                      initialValues={initialCommentValues}
                      onSubmit={onSendBackSubmit}
                      validationSchema={Commentvalidation}>
                      {({ handleSubmit }) => (
                        <Box component="form" noValidate onSubmit={handleSubmit}>
                          <MFTextField
                            name="comment"
                            multiline
                            rows={4}
                            placeholder="Type your answer here..."
                          />

                          <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                            <Button
                              onClick={handleSendBackClose}
                              variant="outlined"
                              sx={{
                                fontSize: 15,
                                color: 'primary.main',
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 500,
                              }}>
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                fontSize: 15,
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 400,
                              }}
                              type="submit">
                              Continue
                            </Button>
                          </Grid>
                        </Box>
                      )}
                    </Formik>
                  </Box>
                </Dialog>
              </Box>
              <Footer />
            </>
            {/* </CommonLayoutForPOA > */}
          </CommonLayout>
        </Box >
      )
  );
};

export default function ApplicationDetails(): JSX.Element {
  const theme = useTheme();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { role = '', subRole = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [application, setApplication] = useState<ApplicationProps>();
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openDialog, setDialog] = useState(false);
  const [openDiyInvCheckerDialog, setDiyInvCheckerDialog] = useState<boolean>(false);
  const [isCurrentStatusNotDraft, setCurrentStatusNotDraft] = useState<boolean>(false);
  const [kraReverificationLoading, setKraReverificationLoading] = useState<boolean>(false);
  const [currentStatus, setCurrentStatus] = useState<string>('');
  const [esignResponse, setEsignResponse] = useState<EsignData>({ status: '', url: '' });
  const { path, url } = useRouteMatch();
  const { userRole = '' } = application?.rm || {};

  const isDiyInvOnboardingApplicationDetails = path.includes('investor-onboarding-application-details')
  const isDiyInvOnboardingApplicationPreview = path.includes('investor-onboarding-application-preview')

  const routerUrl = url.substring(0, url.lastIndexOf('/'))

  //new 
  const { application: applicationDetail } = useSelector((store: RootStateType) => store.application);
  const { currentStep } = applicationDetail || {};

  const isSubBrk = [SUBROLE.SUB_BRK].includes(`${subRole ?? ''}`.toUpperCase() as SUBROLE);

  useEffect(() => {
    (async function () {
      try {
        const _application = (await dispatch(
          getApplicationDetails(id)
        )) as unknown as ApplicationProps;
        setApplication(_application);
        setCurrentStatus(_application?.status?.toLowerCase());
        setCurrentStatusNotDraft(_application?.status?.toLowerCase() !== 'draft')
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    })();
    setLoading(true);
  }, []);

  const { editable, hasPOA, applicationSentBack = false } = application || {};
  const initialCommentValues: Partial<ApplicationProps> = { comment: '' };
  const Commentvalidation = yup.object().shape({
    comment: yup.string().required('Please provide Comment'),
  });
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);

  const handleSendBack = () => setOpenSendBackDialog(true);
  const [sendBackLoading, setSendBackLoading] = useState(false);

  const menuList =
    application &&
    (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
      ? NonIndividualMenuList.map(item =>
        item.currentStep === 0 && (isSubBrk)
          ? { ...item, label: 'Sub Broker/RM Details' }
          : item
      )
      : IndividualMenuList.map(item =>
        item.currentStep === 0 && (isSubBrk)
          ? { ...item, label: 'Sub Broker/RM Details' }
          : item
      ));

  const handleSendBackClose = () => {
    setOpenSendBackDialog(false), setSendBackLoading(false);
  };
  const onSendBackSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleSendBackClose();
      setSendBackLoading(true);
      const { id, status } = application || {};
      if (id) {
        const response = (await dispatch(
          updateApplication({
            body: {
              ...application,
              status:
                isDiyInvOnboardingApplicationPreview
                  ? 'sent_to_amc_approver'
                  : hasPOA
                    ? 'sent_to_poa_approver'
                    : sendApplication_Nri(application) ||
                      (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                      ? 'sent_to_amc_approver'
                      : !AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)
                        ? 'sent_to_applicant1'
                        : status,
              comment: values.comment,
              applicationSentBack: false,
            },
            applicationId: id,
          })
        )) as unknown as ApplicationProps;

        if (!response) {
          setSendBackLoading(false);
          return;
        }
        setCurrentStatus(response?.status?.toLowerCase());
        setCurrentStatusNotDraft(response?.status?.toLowerCase() !== 'draft')

        if (isDiyInvOnboardingApplicationPreview) {
          setDiyInvCheckerDialog(true)
          return
        }

        history.push('/applications');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSendBackLoading(false);
    }
  };
  const handleSubmit = async () => {
    try {
      const { id, status } = application || {};
      setIsSubmitting(true);
      if (id) {
        if (currentStatus === 'draft') {
          const response = (await dispatch(
            updateApplication({
              body: {
                ...application,
                status: 'sent_to_investor',
                //commented for tcl would have to check this again.
                // status:
                //   isDiyInvOnboardingApplicationPreview
                //     ? "sent_to_amc_approver"
                //     : hasPOA
                //       ? 'sent_to_poa_approver'
                //       : // : (status === 'draft' || status === 'sent_to_amc_approver') &&
                //       sendApplication_Nri(application) ||
                // (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                //         ? 'sent_to_amc_approver'
                //         : !AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)
                //           ? 'sent_to_applicant1'
                //           : status,
              },
              applicationId: id,
            })
          )) as unknown as ApplicationProps;

          if (!response) {
            setIsSubmitting(false);
            return;
          }
          setCurrentStatus(response?.status?.toLowerCase());
          setCurrentStatusNotDraft(response?.status?.toLowerCase() !== 'draft');
          history.push('/applications');
        }

        if (isDiyInvOnboardingApplicationPreview) {
          // const res = await dispatch(getEsignLink(id as string)) as unknown as EsignData;
          // setDiyInvCheckerDialog(true);
          // setEsignResponse(res);
          // if (res?.url) {
          //   setTimeout(() => {
          //     window.open(res?.url, '_blank');
          //   }, 1000);
          // }
          // return;
          const { uuid = '', applicants = [] } = application || {};
          const { userId = '', id = '' } = applicants[0] || {};
          const response = await dispatch(GetConsentOtp({ applicantId: id, referenceId: uuid })) as unknown as GetConsentOtpBody;
          if (!response) {
            setIsSubmitting(false);
            return;
          }
          if (response?.phone) {
            history.push('/verify-form-otp', {
              token: response?.verificationToken,
              message: `Please enter the OTP sent to ${response?.phone} and ${response?.email}`,
              application,
              otpRefNo: response?.otpRefNo,
              numberOfTries: response?.numberOfOTPTries
            });
            return;
          }
          return;
        }
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKraReverification = async () => {
    try {
      setKraReverificationLoading(true);

      const response = await (dispatch(kraReverification({
        applicationId: application?.id ?? ''
      })) as unknown as Promise<KraReverificationResponseBody>)

      if (!response) {
        return
      }

      dispatch(showError(response?.message ?? 'KRA reverification success'));

      setApplication(response?.application ?? {});

    } catch (error) {
      console.log(error);
    } finally {
      setKraReverificationLoading(false);
    }
  };


  const isBSEEnabled = !!application?.isBSEEnabled;
  const isKRAVerified = application?.allKRAVerified;

  const isShowKRAButton = isBSEEnabled && !isKRAVerified;

  const LayoutComponent = (isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview) ? InvOnboardingLayout : CommonLayout;

  // return [
  //   USER_ROLES.AMC_ADMIN,
  //   USER_ROLES.RM,
  //   USER_ROLES.DISTRIBUTOR,
  //   USER_ROLES.SUBDISTRIBUTOR,
  //   USER_ROLES.AMC_ADMIN,
  //   USER_ROLES.INVESTOR,
  //   USER_ROLES.ONBOARDING_SPECIALIST
  // ].includes(role) ? (
  return (![USER_ROLES.AMCAPPROVER].includes(role)) ? (
    <LayoutComponent>
      <>
        <Box component={'div'} style={{ marginBottom: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 8px' }}>
          {["/investor-onboarding-application-preview/:id", "/application-preview/:id"].includes(path) ? (
            <Typography variant='h1' sx={{ color: 'text.primary' }}>
              {application?.onboardingType?.toLowerCase() === "minor" ?
                `Minor Investor Onboarding` :
                ""
              }
              {(application?.onboardingType?.toLowerCase() === "normal" &&
                application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                `Individual Investor Onboarding` :
                ""
              }
              {(application?.onboardingType?.toLowerCase() === "normal" &&
                application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                `Non Individual Investor Onboarding` :
                ""
              }
            </Typography >
          ) : (
            [USER_ROLES.AMC_ADMIN].includes(role) ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "20px"
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications"
                  // disabled={approveLoading || rejectLoading}
                  >
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                  </IconButton>
                  <Typography variant='h1' sx={{ color: 'text.primary' }}>Application Details</Typography>
                </Box>
                <Typography variant='h2' sx={{ color: 'text.primary', marginLeft: "35px" }}>
                  {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor` :
                    ""
                  }
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor` :
                    ""
                  }
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor` :
                    ""
                  }
                </Typography>
              </Box>
            ) : (
              <Box>
                <Typography variant='h1' sx={{ color: 'text.primary' }}>Application Details</Typography>
                <Typography variant='h2' sx={{ color: 'text.primary', marginTop: "20px" }}>
                  {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor Onboarding` :
                    ""
                  }
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL)
                    ? application.modeOfHolding === 'single'
                      ? `Individual Investor Onboarding`
                      : `Joint Investor Onboarding`
                    : ""
                  }
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor Onboarding` :
                    ""
                  }
                </Typography>
              </Box>
            )
            // <Typography variant='h1' sx={{ color: 'text.primary' }}>Application Details</Typography>
          )}
          {["/investor-onboarding-application-preview/:id", "/application-preview/:id"].includes(path) && <Typography sx={{ fontWeight: '500', fontSize: 16, letterSpacing: '0.02px', color: 'text.primary' }}>{`Application ID: ${application?.applicationNumber}`}</Typography>}
        </Box>
        <Grid container sx={(theme: Theme) => ({
          p: { xs: '15px', md: '35px' },
          border: `1px solid ${theme.palette.text.secondary}26`,
          borderRadius: "15px",
          background: theme.palette.background.paper,
          position: 'relative'
        })}>
          <Hidden lgDown={true}>
            <Grid item xs={12} lg={3} sx={{ padding: 0, position: 'sticky', top: '18px' }}>
              <Stack sx={{ position: 'sticky', top: '18px', pl: 4, py: 3, display: { lg: 'block', xl: 'block' } }}>
                {/* Stepper */}
                <Stepper
                  activeStep={menuList?.find((item) => item.currentStep == currentStep)?.index || currentStep || 0}
                  orientation="vertical"
                  connector={<BootstrapStepConnector />}
                  sx={{
                    "&.MuiStepper-vertical": {
                      ".MuiStepButton-vertical": {
                        ".MuiStepLabel-vertical": {
                          paddingTop: "0px",
                          paddingBottom: "0px"
                        }
                      }
                    }
                  }}
                >
                  {menuList &&
                    menuList.map((item, index) => {
                      const isItemDisabled = !currentStep ? index !== 0 : index > currentStep;

                      return <Step key={index}>
                        <StepButton
                          href={
                            isDiyInvOnboardingApplicationPreview
                              ? ""
                              : isDiyInvOnboardingApplicationDetails
                                ? `#${item?.link}`
                                : routerUrl === '/application-details' ? !isItemDisabled && application && application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? `#${item?.link}` : `#${item?.link}` : ''
                          }
                          onClick={() =>
                            isDiyInvOnboardingApplicationDetails
                              ? null
                              : isDiyInvOnboardingApplicationPreview
                                ? history.replace(
                                  `/investor-onboarding-application/${item?.link}`,
                                  {
                                    id: application.id,
                                    applicant1ReferenceId: application.applicant1ReferenceId,
                                  }
                                )
                                : routerUrl !== '/application-details' ? !isItemDisabled &&
                                  history.replace(
                                    `${application &&
                                    (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                                      ? `/application/${item?.link}`
                                      : `/application/${item?.link}`)
                                    }`,
                                    {
                                      id: application.id,
                                      applicant1ReferenceId: application.applicant1ReferenceId,
                                    }
                                  ) : null
                          }
                        >
                          <StepLabel
                            sx={(theme: Theme) => ({
                              "& .MuiStepLabel-label.Mui-completed": {
                                ...theme.typography.body_500,
                                color: theme.palette.text.secondary,
                              },
                              "& .MuiStepLabel-label.Mui-active": {
                                ...theme.typography.body_500,
                                color: theme.palette.primary[500]
                              },
                              "& .MuiStepLabel-label.Mui-disabled": {
                                ...theme.typography.body_500,
                                color: theme.palette.text.secondary,
                              },
                              "& .MuiStepLabel-iconContainer.Mui-active": {
                                "& .MuiStepIcon-root.Mui-active": {
                                  color: theme.palette.primary[500]
                                },
                                "& .MuiStepIcon-text": {
                                  ...theme.typography.subtitle_500,
                                  fill: theme.palette.textDark.primary
                                }
                              },
                              "& .MuiStepLabel-iconContainer.Mui-disabled": {
                                "& .MuiStepIcon-root": {
                                  color: theme.palette.grey[100]
                                },
                                "& .MuiStepIcon-text": {
                                  ...theme.typography.subtitle_500,
                                  fill: theme.palette.text.secondary
                                }
                              }
                            })}
                            StepIconComponent={({ completed, ...props }: StepIconProps) => (
                               <StepIcon {...props} icon={(completed || application.modeOfHolding.toLowerCase() == 'joint'||application?.modeOfHolding.toLowerCase()=='either or survivor') ? <StepperSuccessIcon /> : props.icon} />
                              // <StepIcon {...props} icon={(completed || application.modeOfHolding.toLowerCase() == 'joint' ) ? <StepperSuccessIcon /> : props.icon} />
                            )}
                          >
                            {item?.label}
                          </StepLabel>
                        </StepButton>
                      </Step>
                    })}
                </Stepper>

              </Stack>
            </Grid>
          </Hidden>
          <Grid item
            container
            md={12}
            lg={9}
            sx={(theme: Theme) => ({
            })}
          >
            <Box component={'div'} sx={{ padding: { xs: '15px', md: '35px' }, border: `1px solid ${theme.palette.text.secondary}26`, borderRadius: '15px', backgroundColor: `${theme.palette.common.white}`, width: '100%' }}>
              <Box
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 5, gap: 2 }}
                ref={applicationDetailRef}>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  {path === "/investor-onboarding-application-preview/:id" ? (
                    <>
                      <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                        Summary
                      </Typography>
                    </>
                  ) : path === "/application-preview/:id" ? (
                    <>
                      <IconButton
                        sx={{ height: 'fit-content', p: 0 }}
                        component={RouterLink}
                        to="/applications">
                        <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                      </IconButton>

                      <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                        Summary
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', width: '100%', }}>
                        <Box >

                          <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                            <Typography
                              variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                            >
                              Application ID:{' '}
                            </Typography>
                            <Typography
                              variant="inherit"
                              sx={{
                                fontWeight: '400',
                                ...theme.typography.body_500,
                                display: 'inline',
                                color: 'text.primary',

                              }}
                            >
                              {application?.applicationNumber}
                            </Typography>
                          </Typography>

                          <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                            <Typography
                              variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                            >
                              Status:{' '}
                            </Typography>
                            <Typography
                              variant="inherit"
                              sx={(theme: Theme) => ({
                                fontWeight: '400',
                                ...theme.typography.body_500,
                                display: 'inline',
                                color: application?.status === 'sent_to_investor' ? theme.palette.primary[500] : theme.palette.warning[500],
                                textTransform: 'capitalize'

                              })}
                            >
                              {`${APPLICATION_LISTING_STATUS[application?.status ?? '']} ${application?.applicationSentBack ? '(Sent Back)' : ''}`}
                            </Typography>
                          </Typography>

                          {application?.rekycStatus &&
                            <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                              <Typography
                                variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                              >
                                Re-KYC Status:{' '}
                              </Typography>
                              <Typography
                                variant="inherit"
                                sx={(theme: Theme) => ({
                                  fontWeight: '400',
                                  ...theme.typography.body_500,
                                  display: 'inline',
                                  color: application?.rekycStatus === 'completed' ? theme.palette.success[500] : theme.palette.primary[500], textTransform: 'capitalize'

                                })}
                              >
                                {APPLICATION_RE_KYC_STATUS[application?.rekycStatus ?? '']}
                              </Typography>
                            </Typography>
                          }

                        </Box>
                        {application?.clientCode &&
                          <Box>
                            <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                              <Typography
                                variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                              >
                                Client Code:{' '}
                              </Typography>
                              <Typography
                                variant="inherit"
                                sx={(theme: Theme) => ({
                                  fontWeight: '400',
                                  ...theme.typography.body_500,
                                  display: 'inline',
                                  color: 'text.primary',

                                })}
                              >
                                {application?.clientCode}
                              </Typography>
                            </Typography>
                          </Box>
                        }
                      </Box>

                    </>
                  )
                  }

                  {/* <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications">
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                  </IconButton>
                  <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                    Summary
                  </Typography> */}
                </Box>
                {(![USER_ROLES.AMC_ADMIN].includes(role) && application?.modeOfHolding === 'single'
                  // && ((isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview) 
                  //     ? !isCurrentStatusNotDraft || [USER_ROLES.INVESTOR].includes(role)
                  //     : editable 
                  //   )
                  && (([USER_ROLES.RM].includes(role) && currentStatus === 'draft') || ([USER_ROLES.INVESTOR].includes(role) && currentStatus === 'sent_to_investor'))
                ) && (
                    // <IconButton>
                    //   <CardMedia
                    //     component="img"
                    //     src="/images/edit-icon-outlined.svg"
                    //     alt="Edit Icon"
                    //     sx={{ width: 'unset' }}
                    //     onClick={() => history.push(`/application`, { id })}
                    //   />
                    // </IconButton>
                    <Button
                      variant="outlined"
                      startIcon={<EditIcon />}
                      sx={(theme: Theme) => ({
                        padding: '15px',
                        border: `0.5px solid ${theme.palette.text.secondary}`,
                        borderRadius: '10px',
                        color: theme.palette.text.secondary,
                        fontFamily: theme.typography.fontFamily,
                        ...theme.typography.body_500,
                        fontWeight: 700,
                        cursor: 'pointer',

                      })}
                      onClick={() => history.push(`${(isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview) ? "/investor-onboarding-application/personal-details" : "/application"}`, { id })}
                    >
                      Edit
                    </Button>
                  )}
              </Box>
              <ApplicationDetailsCommonLayout
                loading={loading}
                application={application as ApplicationProps}
              />
              {["/investor-onboarding-application-preview/:id", "/application-preview/:id"].includes(path) && application?.modeOfHolding?.toLowerCase() != 'joint' && !([ESIGN_STATUS.PENDING_SIGNATURE].includes(esignResponse?.status)) && (
                <Grid container item xs={12} spacing={3} sx={{ mt: 4, alignSelf: 'center', textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                  {USER_ROLES.RM.includes(role) && (<Grid item xs={12} sm={6}>
                    <Button
                      variant="outlined"
                      fullWidth
                      sx={(theme: Theme) => ({
                        color: theme.palette.primary.main,
                        // minWidth: '200px',
                        // minWidth: "457px",
                        // mt: 4,
                        // fontWeight: 600,
                        // lineHeight: 1.5,
                        // fontSize: '16px',
                        ...theme.typography.body_600
                      })}
                      onClick={() => handleKraReverification()}
                      disabled={!isShowKRAButton || kraReverificationLoading || isSubmitting}
                    >
                      Re-Initiate KRA
                    </Button>
                  </Grid>)}
                  <Grid item xs={12} sm={6} sx={{ alignSelf: 'center', }}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={(theme: Theme) => ({
                        color: 'common.white',
                        // minWidth: '200px',
                        // minWidth: "457px",
                        // mt: 4,
                        // fontWeight: 600,
                        // lineHeight: 1.5,
                        // fontSize: '16px',
                        ...theme.typography.body_600
                      })}
                      onClick={async () => {
                        (sendApplication_Nri(application) ||
                          (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role, isDiyInvOnboardingApplicationPreview))) &&
                          applicationSentBack
                          ? handleSendBack()
                          : setDialog(true);
                      }}
                      disabled={
                        (isSubmitting || sendBackLoading)
                        || (isDiyInvOnboardingApplicationPreview
                          ? !([USER_ROLES.INVESTOR].includes(role) && ['sent_to_investor', 'sent_to_applicant1'].includes(currentStatus))
                          : false
                        ) || isShowKRAButton
                      }

                    >
                      {`${isDiyInvOnboardingApplicationPreview
                        ? "Submit Application"
                        : 'Send to Investor'
                        } 
                      ${isSubmitting || sendBackLoading ? '...' : ''}`}
                      {/* commented for TCL */}
                      {/* {`${isDiyInvOnboardingApplicationPreview
                      ? "Submit for Approval"
                      : application?.hasPOA
                        ? 'Send to POA Approver'
                        : sendApplication_Nri(application) ||
                          (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                          ? 'Send to Checker'
                          : 'Send to Investor'
                      } 
                      ${isSubmitting || sendBackLoading ? '...' : ''}`} */}
                    </Button>
                  </Grid>
                </Grid>
              )}

            </Box>
          </Grid>
        </Grid>
        <IconButton
          sx={{
            position: 'fixed',
            right: 0,
            bottom: 75,
            borderRadius: '5px  0 0 5px',
            '&,:hover': {
              bgcolor: 'primary.main',
            },
          }}
          onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
        </IconButton>
        <Dialog
          onClose={handleSendBackClose}
          open={openSendBackDialog}
          sx={{
            '.MuiPaper-root ': {
              p: 4,
              width: { xs: '70%', sm: '70%' },
            },
          }}>
          <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontSize: 18,
                fontWeight: 500,
                textAlign: 'justify',
              },
            }}>
            <Typography
              sx={{ color: 'primary.main', mt: 2 }}>{`Are you sure you want to send it to ${isDiyInvOnboardingApplicationPreview
                ? "Checker"
                : application?.hasPOA
                  ? 'POA Approver'
                  : sendApplication_Nri(application) ||
                    (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                    ? 'Checker'
                    : 'Investor'
                } ?`}</Typography>
            <Typography sx={{ color: 'primary.main', mt: 2 }}>Provide comments *</Typography>
            <Formik
              initialValues={initialCommentValues}
              onSubmit={onSendBackSubmit}
              validationSchema={Commentvalidation}>
              {({ handleSubmit }) => (
                <Box component="form" noValidate onSubmit={handleSubmit}>
                  <MFTextField
                    name="comment"
                    multiline
                    rows={4}
                    placeholder="Type your answer here..."
                  />

                  <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                    <LoadingButton
                      loading={sendBackLoading}
                      variant="contained"
                      sx={{
                        fontSize: 15,
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 400,
                      }}
                      type="submit">
                      Yes
                    </LoadingButton>
                    <Button
                      onClick={() => {
                        handleSendBackClose();
                      }}
                      variant="outlined"
                      sx={{
                        fontSize: 15,
                        color: 'primary.main',
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 500,
                      }}
                      disabled={sendBackLoading}>
                      No
                    </Button>
                  </Grid>
                </Box>
              )}
            </Formik>
          </Box>
        </Dialog>
        <ConfirmationDialog
          //commented for TCL to reviwe again
          // message={`Sending details to ${isDiyInvOnboardingApplicationPreview
          //   ? 'Checker'
          //   : application?.hasPOA
          //     ? 'POA Approver'
          //     : sendApplication_Nri(application) ||
          //       (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
          //       ? 'Checker'
          //       : 'Investor'
          //   }`}
          message={currentStatus === 'draft' ? 'Sending details to Investor' : (isOnboardingTypeMinor(application?.onboardingType ?? '') || DISABLE_NOMINEE_OPY_OUT) ? 'Verify OTP' : 'Nominee Confirmation'}
          // subMessage={`Are you sure you want to send it to ${isDiyInvOnboardingApplicationPreview
          //   ? 'Checker'
          //   : application?.hasPOA
          //     ? 'POA Approver'
          //     : sendApplication_Nri(application) ||
          //       (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
          //       ? 'Checker'
          //       : 'Investor'
          //   } ?`}
          subMessage={currentStatus === 'draft' ? `Are you sure you want to send it to Investor` :
            (isOnboardingTypeMinor(application?.onboardingType ?? '') || DISABLE_NOMINEE_OPY_OUT) ?
              <Typography>Would you like to proceed to OTP Verification?</Typography> :
              (<Box>
                {(application?.nominees || [])?.length > 0 ?
                  <>
                    <Typography>Please Verify your Nominees.</Typography>
                    <NomineeTable data={application?.nominees || []} />
                    {/* <NomineeDetails nominees={application?.nominees || [] as Partial<NomineeType>[]} application={application || {} as ApplicationProps} showAddress={false} /> */}
                  </> :
                  <Typography>{NO_NOMINEE_DISCLAIMER}</Typography>
                }
              </Box>)
          }
          open={openDialog}
          setOpen={() => setDialog(false)}
          onSave={async () => {
            setDialog(false);
            handleSubmit();
          }}
          onCancel={() => setDialog(false)}
          customWidth='730px'
          primaryButtonText='Confirm'
          secondaryButtonText='Cancel'
        />
        {/* DIY Investor Onboarding Checker Success Dialog Start */}
        <Dialog
          aria-labelledby="success-dialog"
          open={openDiyInvCheckerDialog}
          PaperProps={{
            sx: (theme: Theme) => ({
              maxWidth: '550px',
              width: "100%",
              borderRadius: "12px",
              padding: "24px",
              backgroundColor: theme.palette.common.white
            }),
          }}
        >
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              rowGap: "12px",
              padding: "15px",
              overflow: "hidden"
            }}
          >
            <SuccessIcon />
            <Typography
              variant="h2"
              sx={(theme: Theme) => ({
                lineHeight: "25px",
                letterSpacing: "0.01px",
                color: theme.palette.text.primary
              })}
            >
              Success
            </Typography>
            <Typography
              variant="subtitle_400"
              sx={(theme: Theme) => ({
                lineHeight: "22px",
                letterSpacing: "0.02px",
                color: theme.palette.text.secondary,
                textAlign: "center",
                paddingLeft: "10px",
                paddingRight: "10px"
              })}
            >
              Details successfully sent to Checker
            </Typography>
            <Typography
              variant="subtitle_400"
              sx={(theme: Theme) => ({
                lineHeight: "22px",
                letterSpacing: "0.02px",
                color: theme.palette.text.secondary,
                textAlign: "center",
                paddingLeft: "10px",
                paddingRight: "10px"
              })}
            >
              You will now be redirected to complete your eSign in a new tab and will also receive an email.
            </Typography>
            <Typography
              variant="subtitle_400"
              sx={(theme: Theme) => ({
                lineHeight: "22px",
                letterSpacing: "0.02px",
                color: theme.palette.text.secondary,
                textAlign: "center",
                paddingLeft: "10px",
                paddingRight: "10px"
              })}
            >
              You can log in later to view your Investor Dashboard.
              After successful eSign, your application will be reviewed and approved.
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              padding: "0px",
              marginTop: "40px",
            }}
          >
            <Button
              fullWidth
              variant="contained"
              onClick={() => setDiyInvCheckerDialog(false)}
              sx={(theme: Theme) => ({
                ...theme.typography.body_500,
                fontWeight: 600,
                lineHeight: "20px",
                color: theme.palette.common.white,
                borderRadius: "4px",
                padding: "13px 20px",
                backgroundColor: theme.palette.primary[500]
              })}
            >
              Okay
            </Button>
          </DialogActions>
        </Dialog>
        {/* DIY Investor Onboarding Checker Success Dialog End */}
      </>
    </LayoutComponent>
  ) : (
    <PoaOrNIApplicationDetails loading={loading} application={application as ApplicationProps} />
  );
}
